export default function capitalizeStr(string) {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1).toLowerCase();
}
